import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, useDisclosure } from "@heroui/react";
import RedButton from "/app/src/components/HeroUi/RedButton";
import ModalBuilder from "/app/src/components/HeroUi/helpers/ModalBuilder";

/**
 * Clears logs by calling the provided clearLogs function and handles modal display.
 * @param {object} props - The component properties.
 * @param {function} props.clearLogs - Function to clear logs.
 * @returns {JSX.Element} The rendered component.
 */
export default function ClearLogs({ clearLogs }: { clearLogs: () => void }) {
  const { t } = useTranslation();
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const handleClearLogs = useCallback(() => {
    clearLogs();
    onOpenChange(); // Close the modal after clearing logs
  }, [clearLogs, onOpenChange]);
  return (
    <>
      <Button
        size="sm"
        radius="none"
        variant="bordered"
        color="primary"
        onPress={onOpen}
        className="border-[#a12121] text-[#a12121] bg-white"
      >
        {t("translation:clear")} {t("translation:logs")}
      </Button>
      <Modal
        disableAnimation={false}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement="top"
        aria-label="Confirm delete logs"
      >
        {ModalBuilder({
          warning: true,
          modalHeader: t("translation:confirm_delete_logs"),
          modalFooter: (
            <>
              <Button
                size="sm"
                radius="none"
                color="default"
                variant="bordered"
                onPress={onOpenChange}
                className="hover:border-primary-default hover:text-primary-default"
              >
                {t("translation:cancel")}
              </Button>
              <RedButton radius="none" size="sm" onPress={handleClearLogs}>
                {t("translation:delete")}
              </RedButton>
            </>
          ),
        })}
      </Modal>
    </>
  );
}
